import * as Yup from 'yup';

// Phone number validation schema
export const phoneValidationSchema = Yup.object({
  phone: Yup.string()
    .required('Phone number is required')
    .test('phone-format', 'Please enter valid phone number.', (value) => {
      if (!value) return false;
      const digits = value.replace(/\D/g, '');
      return digits.length === 10;
    }),
});

// SMS code validation schema
export const smsValidationSchema = Yup.object({
  code: Yup.string()
    .required('SMS code is required')
    .matches(/^\d{6}$/, 'Please enter a valid 6-digit code'),
});

// Email validation schema (for future use)
export const emailValidationSchema = Yup.object({
  email: Yup.string()
    .email('Please enter a valid email address')
    .required('Email is required'),
});

// Email OTP validation schema
export const emailOtpValidationSchema = Yup.object({
  code: Yup.string()
    .required('Verification code is required')
    .matches(/^\d{6}$/, 'Please enter a valid 6-digit code'),
});

// Initial values for forms
export const initialValues = {
  phone: '',
  code: '',
  email: '',
};
